import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
export var urlSourceList = '/XOrg/PartnerCourseWare/getSourceList';
export var urlSaveFolder = '/XOrg/PartnerCourseWare/saveFolder';
export var urlsaveUrlSource = '/XOrg/PartnerCourseWare/saveUrlSource';
import http from 'lib/http';
export var urldelCourseWare = '/XOrg/PartnerCourseWare/delCourseWare';
export var urlupdateCourseWare = '/XOrg/PartnerCourseWare/updateCourseWare';
export var urldelallCourseWare = '/XOrg/PartnerCourseWare/delallCourseWare';
export var urlmoveFolder = '/XOrg/PartnerCourseWare/moveFolder';
export var urlgetFolderId = '/XOrg/PartnerCourseWare/getFolderId';
export var urlgetSchoolManageFolderList = '/XOrg/PartnerCourseWare/getSchoolManageFolderList';
export var urlgetStuList = '/XOrg/CourseClass/getClassStu';
export var urlgetSchoolList = '/XOrg/PartnerShareSource/getSchool';
export var urlgetSchoolIdList = '/XOrg/PartnerShareSource/GetSchoolIdList';
export var urlgetTeaList = '/XOrg/PartnerShareSource/GetSchoolCourseSourceTeaList';
export var urlGetPartnerCourseType = '/XOrg/PartnerShareSource/GetPartnerCourseType';
export var urlgetimpoweschoollist = '/XOrg/PartnerShareSource/GetImpowerSchoolList';
export var urlgetnotimpoweschoollist = '/XOrg/PartnerShareSource/GetNotImpowerSchoolList';
export var urlGetCourseBySchool = '/XOrg/PartnerShareSource/GetCourseBySchool';
export var urlgetallimpowerschoollist = '/XOrg/PartnerShareSource/GetAllImpowerSchoolList';
export var urlGetTeacherIsAuthentication = '/XOrg/PartnerCourseWare/GetTeacherIsAuthentication';
export var urlUpdateCourse = '/XOrg/PartnerCourseWare/UpdateCourse';
export var urlschoolAddLabels = '/XOrg/PartnerCourseWare/schoolAddLabels';
export var urlupdateVerify = '/XOrg/PartnerCourseWare/updateVerify';
export function updateVerify(ids, state) {
  return http.post(urlupdateVerify, {
    ids: ids,
    state: state
  });
}
export function moveFolder(ids, fId) {
  return http.post(urlmoveFolder, {
    ids: ids,
    fId: fId
  });
}
export function UpdateCourse(sourceId) {
  return http.post(urlUpdateCourse, {
    sourceId: sourceId
  });
}
export function getFolderId() {
  return http.post(urlgetFolderId, {}).then(function (rst) {
    var folder = {};
    var resultFolder = [];

    if (rst.list && rst.list.length) {
      folder = {};
      rst.list.forEach(function (el) {
        // el.NodePath
        if (el.ParentId === '0') {
          folder[el.Id] = folder[el.Id] || {
            id: el.Id,
            children: []
          };
          folder[el.Id]['label'] = el.FolderName;
          resultFolder.push(folder[el.Id]);
        } else {
          if (el.NodePath && el.NodePath.length) {
            var paths = el.NodePath.split('/');
            var pathsLen = paths.length - 1;

            for (var i = 0; i <= pathsLen; i++) {
              var path = paths[i];

              if (i !== pathsLen) {
                folder[path] = folder[path] || {
                  id: path,
                  children: []
                };
              } else {
                folder[path] = folder[path] || {
                  id: el.Id
                };
                folder[path]['label'] = el.FolderName;
                var parent = folder[el.ParentId];

                if (parent && !parent.children) {
                  parent['children'] = [];
                }

                folder[el.ParentId].children.push(folder[path]);
              }

              folder[el.ParentId] = folder[el.ParentId] || {
                id: el.ParentId,
                children: []
              };
            }
          }
        }
      });
    }

    return resultFolder;
  });
} // 单位管理员获取文件夹列表

export function getSchoolManageFolderList(schoolCourseId, courseId) {
  return http.post(urlgetSchoolManageFolderList, {
    schoolCourseId: schoolCourseId,
    courseId: courseId
  }).then(function (rst) {
    var folder = {};
    var resultFolder = [];

    if (rst.list && rst.list.length) {
      folder = {};
      rst.list.forEach(function (el) {
        // el.NodePath
        if (el.ParentId === '0') {
          folder[el.Id] = folder[el.Id] || {
            id: el.Id,
            children: []
          };
          folder[el.Id]['label'] = el.FolderName;
          resultFolder.push(folder[el.Id]);
        } else {
          if (el.NodePath && el.NodePath.length) {
            var paths = el.NodePath.split('/');
            var pathsLen = paths.length - 1;

            for (var i = 0; i <= pathsLen; i++) {
              var path = paths[i];

              if (i !== pathsLen) {
                folder[path] = folder[path] || {
                  id: path,
                  children: []
                };
              } else {
                folder[path] = folder[path] || {
                  id: el.Id
                };
                folder[path]['label'] = el.FolderName;
                var parent = folder[el.ParentId];

                if (parent && !parent.children) {
                  parent['children'] = [];
                }

                folder[el.ParentId].children.push(folder[path]);
              }

              folder[el.ParentId] = folder[el.ParentId] || {
                id: el.ParentId,
                children: []
              };
            }
          }
        }
      });
    }

    return resultFolder;
  });
}
export function GetSourceList(IsPartner, sort, folderId, type, page, SchoolCourseTypeId, pageSize, courseId) {
  return http.get(urlSourceList, {
    params: {
      IsPartner: IsPartner,
      sort: sort,
      folderId: folderId,
      type: type,
      page: page,
      SchoolCourseTypeId: SchoolCourseTypeId,
      pageSize: pageSize,
      courseId: courseId
    }
  });
}
export var urlSourceInfo = '/XOrg/PartnerCourseWare/getCourseWareInfo';
export function GetSourceInfo(coursewareid) {
  return http.get(urlSourceInfo, {
    params: {
      coursewareid: coursewareid
    }
  });
}
export function saveFolder(folderName, folderId, SchoolCourseTypeId, IsPartner, courseId) {
  return http.post(urlSaveFolder, {
    folderName: folderName,
    folderId: folderId,
    SchoolCourseTypeId: SchoolCourseTypeId,
    IsPartner: IsPartner,
    courseId: courseId
  });
}
export function saveUrlSource(DocPrviewUrl, sourceName, folderId, CourseId, IsPartner, SchoolCourseTypeId) {
  return http.post(urlsaveUrlSource, {
    DocPrviewUrl: DocPrviewUrl,
    CourseWareName: sourceName,
    FolderId: folderId,
    CourseId: CourseId,
    IsPartner: IsPartner,
    SchoolCourseTypeId: SchoolCourseTypeId
  });
}
export function UpdateCourseWare(Id, CourseWareName, txtsourceUrl) {
  return http.get(urlupdateCourseWare, {
    params: {
      Id: Id,
      CourseWareName: CourseWareName,
      txtsourceUrl: txtsourceUrl
    }
  });
}
export function DelCourseWare(Id) {
  return http.post(urldelCourseWare, {
    Id: Id
  });
}
export function delallCourseWare(ids) {
  return http.post(urldelallCourseWare, {
    ids: ids
  });
}
export function getStuList(classId) {
  return http.post(urlgetStuList, {
    classId: classId
  });
} /// 获取单位列表

export function getSchoolList(schoolName, page) {
  return http.post(urlgetSchoolList, {
    schoolName: schoolName,
    page: page
  });
} /// 获取已授权的单位

export function GetSchoolIdList() {
  return http.post(urlgetSchoolIdList, {});
} /// 获取合作伙伴单位课程类型

export function GetPartnerCourseType(SchoolId, MajorId) {
  return http.post(urlGetPartnerCourseType, {
    SchoolId: SchoolId,
    MajorId: MajorId
  });
}
export function GetSchoolCourseSourceTeaList(SchoolCourseTypeId) {
  return http.post(urlgetTeaList, {
    SchoolCourseTypeId: SchoolCourseTypeId
  });
}
export function GetCourseBySchool(SchoolCourseTypeId, Title, page) {
  return http.post(urlGetCourseBySchool, {
    SchoolCourseTypeId: SchoolCourseTypeId,
    Title: Title,
    page: page
  });
}
export function GetImpowerSchoolList(SchoolCourseId, schoolName, page, pageSize) {
  return http.post(urlgetimpoweschoollist, {
    SchoolCourseId: SchoolCourseId,
    schoolName: schoolName,
    page: page,
    pageSize: pageSize
  });
}
export function GetNotImpowerSchoolList(impschoolName, type, page, pageSize) {
  return http.post(urlgetnotimpoweschoollist, {
    impschoolName: impschoolName,
    type: type,
    page: page,
    pageSize: pageSize
  });
} /// 获取单位所有已授权的单位

export function GetAllImpowerSchoolList(schoolName, page, pageSize) {
  return http.post(urlgetallimpowerschoollist, {
    schoolName: schoolName,
    page: page,
    pageSize: pageSize
  });
} /// 获取单位所有已授权的单位

export function GetTeacherIsAuthentication() {
  return http.post(urlGetTeacherIsAuthentication, {});
}
export function schoolAddLabels(id, keyword, mediaType, language, sourceone, author, company, contactInformation) {
  return http.post(urlschoolAddLabels, {
    id: id,
    keyword: keyword,
    mediaType: mediaType,
    language: language,
    sourceone: sourceone,
    author: author,
    company: company,
    contactInformation: contactInformation
  });
}